import { MaskLines, FadeUp } from "../components/Reveal";
import SubscribeForm from "../components/SubscribeForm";
import useSeo from "../lib/useSeo";

export default function Subscribe() {
  useSeo("Subscribe", "Subscribe to Outlaw Creative. New essays, songs and spoken readings, sent as they leave the field.");
  return (
    <section className="relative min-h-[100svh] px-5 sm:px-8 lg:px-12 pt-32 pb-24 grid-bg overflow-hidden flex flex-col justify-center" data-testid="subscribe-page">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_50%,transparent_0%,var(--ink)_65%)]" />
      <svg viewBox="0 0 400 400" className="absolute -right-24 sm:right-0 top-24 w-[420px] sm:w-[560px] opacity-60 pointer-events-none" aria-hidden="true">
        <g className="spin-rev"><circle cx="200" cy="200" r="190" fill="none" stroke="var(--line)" strokeDasharray="3 9" /></g>
        <circle cx="200" cy="200" r="130" fill="none" stroke="var(--line)" />
        <path d="M60 230 C 120 140, 180 300, 240 190 S 340 160, 360 210" fill="none" stroke="var(--bone)" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="200" cy="200" r="4" fill="var(--signal)" />
      </svg>
      <div className="relative max-w-5xl">
        <p className="eyebrow mb-8">03 / Subscribe</p>
        <h1 className="f-display font-black uppercase text-[22vw] sm:text-[16vw] lg:text-[12vw] leading-[0.8]">
          <MaskLines onMount lines={["Begin", <span key="h" className="outline-text">here.</span>]} />
        </h1>
        <FadeUp delay={0.4} className="mt-12 max-w-2xl">
          <p className="f-serif italic text-2xl sm:text-3xl leading-snug text-[#d8d7d1]">This is not a newsletter. It is a line drawn between us.</p>
          <p className="text-lg text-[#bdbcb5] mt-4">New essays, songs and spoken readings, sent as they leave the field.</p>
          <div className="mt-12"><SubscribeForm id="subscribe" large /></div>
          <p className="f-mono text-[11px] text-[var(--ash)] mt-5">No noise. Leave whenever you like.</p>
        </FadeUp>
      </div>
    </section>
  );
}
